export type PaymentId = string;
export interface PaymentMethodRequest {
  name: string;
  cardNumber: string;
  expiryMonth: number | string;
  expiryYear: number | string;
  cvv: string;

  addressId?: string;

  address?: string;
  addressLineTwo?: string | null;
  city?: string;
  state?: string;
  postal?: string;
  country?: string;
}

export interface CardMethodRequest {
  name: string;
  cardNumber: string;
  expiryMonth: number;
  expiryYear: number;
  cvv: string;
}
export interface ACHMethodRequest {
  name: string;
  //   phone: number;
  routingNumber: number | string;
  accountNumber: number | string;
  accountType: ACHAccountType;
}

export enum PaymentMethodType {
  card = 'card',
  ach = 'ach',
}

export enum ACHAccountType {
  personalCurrent = 'PERSONAL_CHECKING',
  personalSaving = 'PERSONAL_SAVINGS',
  businessCurrent = 'BUSINESS_CHECKING',
  businessSaving = 'BUSINESS_SAVINGS',
}

export interface PaymentMethodResponse {
  id: PaymentId;
  name: string;
  type: PaymentMethodType;
  cardType: string;
  cardDigits: string;
  cardExpiry: string;
  service: string;
  subscriptions: string[];
  default: boolean;
  nextSteps?: PaymentMethodNextStepResponse;
}

export interface PaymentMethodNextStepResponse {
  url: string;
  type: string;
}

export enum ManualPaymentMethodType {
  creditCard = 'Credit Card',
  ach = 'ACH',
  wire = 'Wire',
  check = 'Check',
  other = 'Other',
}

export interface QBPaymentMethodItem {
  id: string;
  type: string;
  name: string;
  actvie: boolean;
}
export interface QBAccountItem {
  id: string;
  name: string;
  type: string;
  currency: string;
  active: boolean;
}

export enum QBCustomFieldType {
  po = 'po',
  invoice = 'invoice',
}

export interface QBCustomField {
  id: string;
  type: QBCustomFieldType;
  name: string;
  valueType: string;
}

export interface QBAccountItem {
  id: string;
  name: string;
  type: string;
  currency: string;
  active: boolean;
}

export interface QBModulesResponse {
  customers: number;
  invoices: number;
  products: number;
  services: number;
  classes: number;
  payments: number;
  subscriptions: number;
}

export interface QBImportRequest {
  customers: boolean;
  invoices: boolean;
  products: boolean;
  services: boolean;
  payments: boolean;
  subscriptions: boolean;
}

export interface PaymentSuccessResponse {
  success: boolean;
  message: string;
}
